import { render, staticRenderFns } from "./panel-proposals.vue?vue&type=template&id=6bc76aee&scoped=true&"
import script from "./panel-proposals.vue?vue&type=script&lang=js&"
export * from "./panel-proposals.vue?vue&type=script&lang=js&"
import style0 from "./panel-proposals.vue?vue&type=style&index=0&id=6bc76aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc76aee",
  null
  
)

export default component.exports